import {
  BackendService,
  BrandService,
  ConfigService,
  MapCoord,
  MapFilter,
  MapLayer,
  MapLegend,
  StateService,
  UtilityService
}                           from './';
import { BehaviorSubject }  from 'rxjs';
import {
  Inject,
  Injectable
}                           from '@angular/core';

export interface GeofenceCallback	{ (image:	string):	void }

@Injectable()
export class MapService {
  gmaps: 			any;
	gmapsReady: any[] = [];
  map: 				any;

  readyTracker = 0;

	filterData:				any;
	legendTracker			= 0;
	watchingGeofence	= false;

	layers:	MapLayer[] = [];
	legend	= new BehaviorSubject<MapLegend[]>([]);
	popup		= new BehaviorSubject("");

	private filterStatusKey   = 'electra-filter-status';

  filter: BehaviorSubject<MapFilter[]>;

  currentZoom = 0;

  layerManager: LayerManager;
	
	get filterStatus(): MapFilter[] {
		var
		filters = this.utilityService.getLocalStorageArray(this.filterStatusKey),
		retVal: MapFilter[] = []

		if (Array.isArray(filters)) {
			for (var i = 0, len = filters.length; i < len; i++) {
				retVal.push(new MapFilter(filters[i]))
			}
		} else {
			this.utilityService.setLocalStorageData(this.filterStatusKey, retVal);
		}

		return retVal
	}

	set filterStatus(filterStatus: MapFilter[]) {
		var temp: any[] = []

		for (var i = 0, len = filterStatus.length; i < len; i++) {
			temp.push({
				text:			filterStatus[i].text,
				toggled:	filterStatus[i].toggled
			})
		}
		
		this.utilityService.setLocalStorageData(this.filterStatusKey, temp);
	}

  constructor(
    private brandService:   BrandService,
    public backendService:  BackendService,
    private configService:  ConfigService,
    private stateService:   StateService,
    private utilityService: UtilityService
  ) {
    this.utilityService.injectScript(
      'https://maps.googleapis.com/maps/api/js?v=3&key=' + brandService.googleMapsKey,
      'google',
      google => {
        this.gmaps = google.maps;

        this.trackReady();
      },
      this
    );

    this.filter = new BehaviorSubject(this.filterStatus);

    backendService.getFilters(this.gotFilters, this);
		backendService.getLegend(this.gotLegend, this);

    console.log('Map service created');
  }

  trackReady() {
    if (++this.readyTracker == 2) {
      for (var i = 0, len = this.gmapsReady.length; i < len; i++) {
        this.gmapsReady[i].callback.call(this.gmapsReady[i].context);
      }
    }
  }

  getGeofence(geofence: string, callback: any, context: any) {
    this.backendService.getGeofence(geofence, {
      lat: this.map.getCenter().lat(),
      lng: this.map.getCenter().lng()
    }, callback, context);
	}
  
  getMap(id: string, options: any) {
    this.map = new this.gmaps.Map(document.getElementById("gmap"), options);
		this.map.setCenter({lat: 35, lng: -85});
		this.map.setZoom(2);

		this.backendService.getMapLayers(this.gotMapData, this);

    this.gmaps.event.addListener(this.map, 'idle', () => { this.mapIdled(); });
    this.trackReady();

    //this.layerManager = new LayerManager(this.gmaps, this.map);
  }

	getProperties(layer: string, feature: number, callback: any, context: any) {
		this.backendService.getMapProperties(layer, feature, callback, context);
	}

	gotFilters(data: string[]) {
		if (this.layers.length > 0) {
			var
			status	= this.filterStatus,
			temp:		MapFilter[] = [];

			for (var i = 0, len = data.length; i < len; i++) {
				var
				layer:	MapLayer,
				toggled = true;

				for (var k = 0, lenk = this.layers.length; k < lenk; k++) {
					if (this.layers[k].filterText === data[i]) {
						layer = this.layers[k];
						
						for (var j = 0, lenj = status.length; j < lenj; j++) {
							if (status[j].text === data[i]) {
								toggled = status[j].toggled;
								
								break;
							}
						}

						break;
					}
				}

				let filter = new MapFilter(data[i], toggled, layer);
				layer.filter = filter;
				layer.setFeatures(toggled);

				temp.push(filter);
			}

			this.filter.next(temp);

			this.filterStatus = temp;
		} else {
			this.filterData = data;
		}
	}

	gotLegend(data: any[]) {
		var temp: MapLegend[] = [];

		for (var i = 0, len = data.length; i < len; i++) {
			if (data[i].color) {
				temp.push(new MapLegend(this.configService, data[i].text, data[i].color));
			} else {
				temp.push(new MapLegend(this.configService, data[i].text, null, data[i].image));
			}
		}

		this.legend.next(temp);
	}

	gotMapData(data: any[]) {
		var count = 0;

		for (var i = 0, len = data.length; i < len; i++) {
			this.layers.push(new MapLayer(data[i], i, () => {
				if (++count === data.length) {
          setTimeout(t => {
            t.gmaps.event.trigger(t.map, 'idle');
          }, 100, this);
					this.gotFilters.call(this, this.filterData);
				}
			}, this.configService, this));
		}
	}

	setFilter() {
		this.filter.next(this.filter.value);

		this.filterStatus = this.filter.value;
	}

  setPosition(coord: MapCoord) {
		this.map.panTo(coord);
		this.map.setZoom(17);
  }

  mapIdled() {
    var newZoom = this.map.getZoom();

    if (newZoom !== this.currentZoom) {
      this.currentZoom = newZoom;

      for (var i = 0, len = this.layers.length; i < len; i++) {
        //if (this.layers[i].resolutions.length > 1) {
          this.layers[i].zoomChanged = true;
        //}
      }
    }

    var startTime = new Date().getTime();
    var modifier  = 3; 
    var bounds    = new Bounds();
    var newBounds = this.map.getBounds();
    var neBounds  = newBounds.getNorthEast();
    var swBounds  = newBounds.getSouthWest();

    bounds.minLng = swBounds.lng();
    bounds.minLat = swBounds.lat();
    bounds.maxLng = neBounds.lng();
    bounds.maxLat = neBounds.lat();
    bounds.lngpp  = (bounds.maxLng - bounds.minLng) / document.body.clientWidth * modifier;
    bounds.latpp  = (bounds.maxLat - bounds.minLat) / document.body.clientHeight * modifier;

    for (var i = 0, len = this.layers.length; i < len; i++) {
      setTimeout((t, i2) => {
        t.layers[i2].checkBounds(bounds, newZoom);
      }, 10, this, i);
    }
    console.log(new Date().getTime() - startTime);
  }

  watchGeofence(geofence: string, callback: GeofenceCallback) {
    this.map.addListener('idle', () => {
      if (!this.watchingGeofence) {
        this.watchingGeofence = true

        setTimeout((t: MapService, geofence: string, callback: GeofenceCallback) => {
          t.watchingGeofence = false

          t.getGeofence(geofence, callback, t);
        }, 500, this, geofence, callback)
      }
    })

    this.gmaps.event.trigger(this.map, 'idle');
	}
}

class LayerManager {
  gmaps: any;
  map: any;

  zoom = new BehaviorSubject<number>(0);
  bounds = new BehaviorSubject<Bounds>(new Bounds());

  modifier = 4;

  constructor(gmaps, map) {
    this.gmaps = gmaps;
    this.map = map;

    this.gmaps.event.addListener(this.map, 'idle', () => { this.mapIdled(); });

    this.zoom.subscribe(val => { console.log(val); });
    this.bounds.subscribe(val => { console.log(val); });
  }

  mapIdled() {
    var bounds    = this.bounds.getValue();
    var newBounds = this.map.getBounds();
    var neBounds  = newBounds.getNorthEast();
    var swBounds  = newBounds.getSouthWest();
    var zoom      = this.zoom.getValue();
    var newZoom   = this.map.getZoom();

    if (zoom !== newZoom) {
      this.zoom.next(newZoom);
    }

    bounds.minLng = swBounds.lng();
    bounds.minLat = swBounds.lat();
    bounds.maxLng = neBounds.lng();
    bounds.maxLat = neBounds.lat();
    bounds.lngpp = (bounds.maxLng - bounds.minLng) / document.body.clientWidth * this.modifier;
    bounds.latpp = (bounds.maxLat - bounds.minLat) / document.body.clientHeight * this.modifier;

    this.bounds.next(bounds);
  }
}

class Layer {
  coordinates:  [any];
  resolutions:  [any];
  features:     [any];
}

class PolygonLayer extends Layer {

}

export class Bounds {
  minLng = 0;
  maxLng = 0;
  minLat = 0;
  maxLat = 0;
  lngpp = 0;
  latpp = 0;
}



// WEBPACK FOOTER //
// ./src/app/electraLib/service/map.service.ts